var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSafety = function SvgSafety(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 18 17",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.413 0c.853 0 1.634.551 1.831 1.308L15.726 12h.389c1.06 0 1.882.903 1.882 1.968l-.004.982c.091 1.097-.746 2.05-1.834 2.05H1.881C.822 17 0 16.097 0 15.032v-1.064C0 12.903.822 12 1.881 12h.39l.797-2.483L5.73 1.251A1.94 1.94 0 0 1 7.54 0h2.873Zm5.584 14H2v1h13.997v-1Zm-3.026-4H5.012l-.042.13-.6 1.87h9.252l-.651-2ZM11.67 6H6.3l-.644 2h6.664l-.65-2Zm-1.302-4h-2.78l-.644 2h4.075l-.651-2Z"
  })));
};
export default SvgSafety;